import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=ca3b952e"
import script from "./ReminderList.vue?vue&type=script&lang=js"
export * from "./ReminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports